import { iconButtonCompoundVariants, iconButtonDisabledVariants, iconButtonEmphasisVariants, iconButtonShadowVariants, iconButtonSizeVariants, iconButtonSlots, iconButtonTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const iconAVariants = tv({
    slots: iconButtonSlots,
    variants: {
        type: iconButtonTypeVariants,
        size: iconButtonSizeVariants,
        emphasis: iconButtonEmphasisVariants,
        shadow: iconButtonShadowVariants,
        disabled: iconButtonDisabledVariants
    },
    compoundVariants: iconButtonCompoundVariants,
    defaultVariants: {
        type: 'secondary',
        emphasis: 'regular',
        size: 'md'
    }
});
export { iconAVariants };
